$(document).on('submit','.newsletter-signup form',function(){
	var requiredFields = $(this).find('.required-field');
	var valid = true;
	for(r=0; r < requiredFields.length; r++) {
		var thisItem = requiredFields[r];
		if($(thisItem).find('input').val() == '') {
			var thisID = $(thisItem).find('input').attr('id');
			$(thisItem).addClass('error');		
			$(thisItem).find('.newsletter-error[data-id="' + thisID + '"]').html('This field is required.').addClass('show');
			valid = false;	
		}
	}
	if(valid) {
		var newsletterWrapper = $(this).closest('.newsletter-wrapper');
		$(newsletterWrapper).addClass('success');
		$(newsletterWrapper).find('.newsletter-success-message').html('Thank you, your sign-up request was successful!<span>Please check your email inbox to confirm.</span>');
	}
	return false;
});